// extracted by mini-css-extract-plugin
export default {"main":"NewProduct_main__vazv8"};